import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import DashboardView from '@/dashboard/DashboardView.vue'
import {NavGroup, registerNavigationEntry} from '@/navigation'

export const DASHBOARD = {componentName: 'Dashboard', component: DashboardView, meta: {requiresOrg: true}}
const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()

const icon = 'i-ph-house-fill'
const label = 'Startside'
const hotkey = 'z'
const route = DASHBOARD

registerNavigationCommand({
    route,
    label,
    icon,
    hotkey
})
registerNavigationEntry(NavGroup.START, {
    title: label,
    key: 'dashboard',
    icon,
    target: route,
    sortOrder: 1,
})

registerHotkey(hotkey, DASHBOARD)
registerRoute(route)
buildSimpleCrumb(route, label, icon)